import { FC } from 'react';

const NoGlutenIcon: FC = () => {
  return (
    <svg
      width="71"
      height="70"
      viewBox="0 0 71 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.667 59.6465V16.7715"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="1.989"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M29.1045 43.0202V10.3535C29.3962 13.9993 32.4587 16.6243 35.9587 16.4785C39.167 16.3327 41.792 13.7077 42.0837 10.3535V43.0202"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1045 21.291C29.3962 24.9368 32.4587 27.5618 35.9587 27.416C39.167 27.2702 41.792 24.6452 42.0837 21.291"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1045 32.084C29.3962 35.7298 32.4587 38.3548 35.9587 38.209C39.167 38.0632 41.792 35.4382 42.0837 32.084"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.1045 43.0215C29.3962 46.6673 32.4587 49.2923 35.9587 49.1465C39.167 49.0007 41.792 46.3757 42.0837 43.0215"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.667 65.625C52.5807 65.625 66.292 51.9137 66.292 35C66.292 18.0863 52.5807 4.375 35.667 4.375C18.7533 4.375 5.04199 18.0863 5.04199 35C5.04199 51.9137 18.7533 65.625 35.667 65.625Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M52.001 52.5L56.5218 57.3125"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.958 12.834L20.6455 18.959"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NoGlutenIcon;
